<div v-if="shouldRenderConfig" v-bind:class="getClassName">
    <div class="matrix_quantityFieldLabel">{{ $t(name) }}</div>
    <input type="number" v-model="quantity" onkeydown="return event.keyCode !== 69" v-on:keydown.enter="onQuantity" v-on:blur="onQuantity"/>
</div>

